export default "__VITE_ASSET__D7kApv4N__"